module.exports = __webpack_public_path__ + "img/colazione_5.229642a2.jpeg";